const trimmed = (value) => String(value || '').trim();

export const aprenderAliases = (row) => {
  const english = trimmed(row?.name);
  const spanish = trimmed(row?.spanishName);
  const aliases = [];
  if (english) aliases.push(english);
  if (spanish && spanish.toLowerCase() !== english.toLowerCase()) aliases.push(spanish);
  return aliases;
};

export const aprenderDisplayTitle = (row) => {
  const [english, spanish] = aprenderAliases(row);
  if (english && spanish) return `${english} / ${spanish}`;
  return english || spanish || '';
};

export const mapAprenderReference = (row) => {
  if (!row || row.isArchived || !row.transparent) return null;
  const title = aprenderDisplayTitle(row);
  if (!title) return null;
  return {
    _id: row._id,
    title,
    aliases: aprenderAliases(row),
    imageUrl: row.transparent,
    thumbnailUrl: row.transparent,
    source: 'aprender',
  };
};
